import { render, staticRenderFns } from "./Abgangsfeld.vue?vue&type=template&id=da967224&scoped=true&"
import script from "./Abgangsfeld.vue?vue&type=script&lang=js&"
export * from "./Abgangsfeld.vue?vue&type=script&lang=js&"
import style0 from "./Abgangsfeld.vue?vue&type=style&index=0&id=da967224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da967224",
  null
  
)

component.options.__file = "Abgangsfeld.vue"
export default component.exports